'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeSellerSearchTermsPast = exports.changeSellerSearchTermsUpcoming = exports.changeStoreFrontSearchTerms = exports.changeStorefrontPage = exports.changeSellerPagePast = exports.changeSellerPageUpcoming = exports.changeSavedItemsSearchTerms = exports.changeSavedItemsPage = exports.changeProfileTab = exports.changeMySavedSearchSearchRecentTerms = exports.changeMySavedSearchRecentPage = exports.changeMySavedSearchSearchManageTerms = exports.changeMySavedSearchManagePage = exports.changeMyBidsTab = exports.changeMyBidsSearchTerms = exports.changeMyBidsPage = exports.changeMyAuctionsTab = exports.changeMyAuctionsSearchTerms = exports.changeMyAuctionsPage = exports.changeFollowedSellersSearchTerms = exports.changeFollowedSellersPage = exports.changeCatalogSearchTerms = exports.changeCatalogPage = exports.getStorefrontViewData = exports.getSellerViewData = exports.getSavedItemsViewData = exports.getProfileViewData = exports.getMySavedSearchRecentViewData = exports.getMySavedSearchManageViewData = exports.getMyBidsViewData = exports.getMyAuctionsViewData = exports.getFollowedSellersViewData = exports.getCatalogViewData = exports.MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY = exports.MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY = exports.CHANGE_VIEW_DATA_TAB = exports.CHANGE_VIEW_DATA_SEARCH_TERMS = exports.CHANGE_VIEW_DATA_PAGE = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_VIEW_DATA_PAGE = exports.CHANGE_VIEW_DATA_PAGE = 'la/ui/viewData/page';
var CHANGE_VIEW_DATA_SEARCH_TERMS = exports.CHANGE_VIEW_DATA_SEARCH_TERMS = 'la/ui/viewData/searchTerms';
var CHANGE_VIEW_DATA_TAB = exports.CHANGE_VIEW_DATA_TAB = 'la/ui/viewData/tab';

var MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY = exports.MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY = 'my-saved-search-manage';
var MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY = exports.MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY = 'my-saved-search-recent';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_VIEW_DATA_PAGE:
            return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends6.default)({}, state[action.payload.id], { page: action.payload.page })));
        case CHANGE_VIEW_DATA_SEARCH_TERMS:
            return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends6.default)({}, state[action.payload.id], {
                searchTerms: action.payload.searchTerms
            })));
        case CHANGE_VIEW_DATA_TAB:
            return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.payload.id, (0, _extends6.default)({}, state[action.payload.id], { tab: action.payload.tab })));
        default:
            return state;
    }
}

/* SELECTORS */
var getCatalogViewData = exports.getCatalogViewData = function getCatalogViewData(state, catalogId) {
    var viewData = state.ui.viewData['catalog-' + catalogId] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getFollowedSellersViewData = exports.getFollowedSellersViewData = function getFollowedSellersViewData(state) {
    var viewData = state.ui.viewData['followed-sellers'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getMyAuctionsViewData = exports.getMyAuctionsViewData = function getMyAuctionsViewData(state) {
    var viewData = state.ui.viewData['my-auctions'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || '',
        tab: viewData.tab || 'approved'
    };
};

var getMyBidsViewData = exports.getMyBidsViewData = function getMyBidsViewData(state) {
    var viewData = state.ui.viewData['my-bids'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || '',
        tab: viewData.tab || 'upcoming'
    };
};

var getMySavedSearchManageViewData = exports.getMySavedSearchManageViewData = function getMySavedSearchManageViewData(state) {
    var viewData = state.ui.viewData[MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getMySavedSearchRecentViewData = exports.getMySavedSearchRecentViewData = function getMySavedSearchRecentViewData(state) {
    var viewData = state.ui.viewData[MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getProfileViewData = exports.getProfileViewData = function getProfileViewData(state) {
    var viewData = state.ui.viewData.profile || {};
    return {
        tab: viewData.tab || 'my-profile'
    };
};

var getSavedItemsViewData = exports.getSavedItemsViewData = function getSavedItemsViewData(state) {
    var viewData = state.ui.viewData['saved-items'] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getSellerViewData = exports.getSellerViewData = function getSellerViewData(state) {
    var which = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'upcoming';
    var sellerId = arguments[2];

    var viewData = state.ui.viewData['seller-' + sellerId + '-' + which] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

var getStorefrontViewData = exports.getStorefrontViewData = function getStorefrontViewData(state, sellerId) {
    var viewData = state.ui.viewData['storefront-' + sellerId] || {};
    return {
        page: viewData.page || 1,
        searchTerms: viewData.searchTerms || ''
    };
};

/* ACTION CREATORS */
var changeViewDataPage = function changeViewDataPage(id, page) {
    return {
        payload: { id: id, page: Number(page) },
        type: CHANGE_VIEW_DATA_PAGE
    };
};

var changeViewDataSearchTerms = function changeViewDataSearchTerms(id, searchTerms) {
    return {
        payload: { id: id, searchTerms: searchTerms },
        type: CHANGE_VIEW_DATA_SEARCH_TERMS
    };
};

var changeViewDataTab = function changeViewDataTab(id, tab) {
    return {
        payload: { id: id, tab: tab },
        type: CHANGE_VIEW_DATA_TAB
    };
};

var changeCatalogPage = exports.changeCatalogPage = function changeCatalogPage(catalogId, page) {
    return changeViewDataPage('catalog-' + catalogId, page);
};

var changeCatalogSearchTerms = exports.changeCatalogSearchTerms = function changeCatalogSearchTerms(catalogId, searchTerms) {
    return changeViewDataSearchTerms('catalog-' + catalogId, searchTerms);
};

var changeFollowedSellersPage = exports.changeFollowedSellersPage = function changeFollowedSellersPage(page) {
    return changeViewDataPage('followed-sellers', page);
};

var changeFollowedSellersSearchTerms = exports.changeFollowedSellersSearchTerms = function changeFollowedSellersSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('followed-sellers', searchTerms);
};

var changeMyAuctionsPage = exports.changeMyAuctionsPage = function changeMyAuctionsPage(page) {
    return changeViewDataPage('my-auctions', page);
};

var changeMyAuctionsSearchTerms = exports.changeMyAuctionsSearchTerms = function changeMyAuctionsSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('my-auctions', searchTerms);
};

var changeMyAuctionsTab = exports.changeMyAuctionsTab = function changeMyAuctionsTab(tab) {
    return changeViewDataTab('my-auctions', tab);
};

var changeMyBidsPage = exports.changeMyBidsPage = function changeMyBidsPage(page) {
    return changeViewDataPage('my-bids', page);
};

var changeMyBidsSearchTerms = exports.changeMyBidsSearchTerms = function changeMyBidsSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('my-bids', searchTerms);
};

var changeMyBidsTab = exports.changeMyBidsTab = function changeMyBidsTab(tab) {
    return changeViewDataTab('my-bids', tab);
};

var changeMySavedSearchManagePage = exports.changeMySavedSearchManagePage = function changeMySavedSearchManagePage(page) {
    return changeViewDataPage(MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY, page);
};

var changeMySavedSearchSearchManageTerms = exports.changeMySavedSearchSearchManageTerms = function changeMySavedSearchSearchManageTerms(searchTerms) {
    return changeViewDataSearchTerms(MY_SAVED_SEARCH_MANAGE_VIEW_DATA_KEY, searchTerms);
};

var changeMySavedSearchRecentPage = exports.changeMySavedSearchRecentPage = function changeMySavedSearchRecentPage(page) {
    return changeViewDataPage(MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY, page);
};

var changeMySavedSearchSearchRecentTerms = exports.changeMySavedSearchSearchRecentTerms = function changeMySavedSearchSearchRecentTerms(searchTerms) {
    return changeViewDataSearchTerms(MY_SAVED_SEARCH_RECENT_VIEW_DATA_KEY, searchTerms);
};

var changeProfileTab = exports.changeProfileTab = function changeProfileTab(tab) {
    return changeViewDataTab('profile', tab);
};

var changeSavedItemsPage = exports.changeSavedItemsPage = function changeSavedItemsPage(page) {
    return changeViewDataPage('saved-items', page);
};

var changeSavedItemsSearchTerms = exports.changeSavedItemsSearchTerms = function changeSavedItemsSearchTerms(searchTerms) {
    return changeViewDataSearchTerms('saved-items', searchTerms);
};

var changeSellerPageUpcoming = exports.changeSellerPageUpcoming = function changeSellerPageUpcoming(sellerId, page) {
    return changeViewDataPage('seller-' + sellerId + '-upcoming', page);
};

var changeSellerPagePast = exports.changeSellerPagePast = function changeSellerPagePast(sellerId, page) {
    return changeViewDataPage('seller-' + sellerId + '-past', page);
};

var changeStorefrontPage = exports.changeStorefrontPage = function changeStorefrontPage(sellerId, page) {
    return changeViewDataPage('storefront-' + sellerId, page);
};

var changeStoreFrontSearchTerms = exports.changeStoreFrontSearchTerms = function changeStoreFrontSearchTerms(sellerId, searchTerms) {
    return changeViewDataSearchTerms('storefront-' + sellerId, searchTerms);
};

var changeSellerSearchTermsUpcoming = exports.changeSellerSearchTermsUpcoming = function changeSellerSearchTermsUpcoming(sellerId, searchTerms) {
    return changeViewDataSearchTerms('seller-' + sellerId + '-upcoming', searchTerms);
};

var changeSellerSearchTermsPast = exports.changeSellerSearchTermsPast = function changeSellerSearchTermsPast(sellerId, searchTerms) {
    return changeViewDataSearchTerms('seller-' + sellerId + '-past', searchTerms);
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/viewData.js
// module id = +NGn
// module chunks = 60